import React from "react"
import PropTypes from "prop-types"
// import Container from "../../hoc/container/Container"

import icon1 from "../../assets/icons/benefits/1.svg"
import icon2 from "../../assets/icons/benefits/2.svg"
import icon3 from "../../assets/icons/benefits/3.svg"
import icon4 from "../../assets/icons/benefits/4.svg"
import icon5 from "../../assets/icons/benefits/5.svg"
import icon6 from "../../assets/icons/benefits/6.svg"

import style from "./BenefitsBanner.module.css"

const BenefitsBanner = props => {
  const { index } = props
  const content = [
    [
      {
        src: icon1,
        text: <>Coaching tools and loss aversion help you stay on track.</>,
      },
      {
        src: icon2,
        text: (
          <>
            Earn points which can be exchanged for rewards and pieces of art
            unique to your journey.
          </>
        ),
      },
    ],
    [
      {
        src: icon3,
        text: (
          <>
            Connect with family, friends and community members with shared
            goals.
          </>
        ),
      },
      {
        src: icon4,
        text: (
          <>
            Send each other motivation and appreciation that can be stored and
            replayed later.
          </>
        ),
      },
    ],
    [
      {
        src: icon5,
        text: (
          <>
            <span>Full privacy options.</span>
            <br />
            Complete control over what information you share.
          </>
        ),
      },
      {
        src: icon6,
        text: (
          <>
            Secure cloud platform. Compliant with EU and US data protection
            laws.
          </>
        ),
      },
    ],
  ]

  return (
    <div className={style.container}>
      {content[index].map((block, index) => {
        return (
          <div key={index}>
            <img src={block.src} alt={block.text} />
            <p>{block.text}</p>
          </div>
        )
      })}
    </div>
  )
}

BenefitsBanner.propTypes = {
  index: PropTypes.number.isRequired,
}
// Props for which section
BenefitsBanner.defaultProps = {
  index: 0,
}

export default BenefitsBanner
